import ClinicPoint from './coordinates/Perm/ClinicPoint.json';
import PermOverKama from './coordinates/Perm/PermOverKama.json';

export default {
    regionCode: 'perm',
    serviceAreas: [
        {
            id: 'perm-1',
            include: [
                {
                    name: 'клиника на Петропавловской, 43 (расстояние 10км)',
                    type: 'point',
                    distance: true,
                    maxDistance: 10,
                    coordinates: ClinicPoint
                },
            ],
            exclude: [
                {
                    name: 'Пермь выше реки Кама',
                    type: 'polygon',
                    coordinates: PermOverKama,
                }
            ],
        },
        {
            id: 'perm-2',
            include: [
                {
                    name: 'клиника на Петропавловской, 43 (расстояние 20км)',
                    type: 'point',
                    distance: true,
                    maxDistance: 20,
                    coordinates: ClinicPoint
                },
            ],
        },
        {
            id: 'perm-3',
            include: [
                {
                    name: 'клиника на Петропавловской, 43 (расстояние 30км)',
                    type: 'point',
                    distance: true,
                    maxDistance: 30,
                    coordinates: ClinicPoint
                },
            ],
        },
        {
            id: 'perm-4',
            include: [
                {
                    name: 'клиника на Петропавловской, 43 (расстояние 50км)',
                    type: 'point',
                    distance: true,
                    maxDistance: 50,
                    coordinates: ClinicPoint
                },
            ],
        },
    ]
};
